import { render } from "./input-textarea.vue?vue&type=template&id=3a4f8050&scoped=true"
import script from "./input-textarea.vue?vue&type=script&lang=js"
export * from "./input-textarea.vue?vue&type=script&lang=js"

import "./input-textarea.vue?vue&type=style&index=0&id=3a4f8050&scoped=true&lang=scss"

import exportComponent from "/home/gebruiker/www/fresh/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a4f8050"]])

export default __exports__